import React from "react";
import classes from "./BottomSheetActionButton.module.css";

const BottomSheetActionButton = ({ children, onClick, dropClass }) => {
    return (
        <button type="button" className={`${classes.BottomSheetActionButton} ${dropClass || ""}`} onClick={onClick}>
            {children}
        </button>
    );
};

export default BottomSheetActionButton;
